export const cognitoAttributeFieldMappings = {
    given_name: 'firstName',
    family_name: 'lastName',
    email: 'email'
};